// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__mQ-NP","detailContainer":"Dashboard_detailContainer__LqFVx"};